import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useI18n } from "../i18n/I18nContext";

export default function NewsletterForm() {
  const { t } = useI18n();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [consent, setConsent] = useState(true);
  const [error, setError] = useState("");

  const validateEmail = (val) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || !validateEmail(email) || !consent) {
      setError("*");
      return;
    }
    setError("");
    try {
      const list = JSON.parse(
        localStorage.getItem("metrosenda_leads") || "[]",
      );
      list.push({
        name: name.trim(),
        email: email.trim(),
        ts: new Date().toISOString(),
      });
      localStorage.setItem("metrosenda_leads", JSON.stringify(list));
    } catch (err) {
      // ignore storage errors
    }
    if (window.gtag) {
      window.gtag("event", "generate_lead", { method: "newsletter" });
    }
    navigate("/thank_you");
  };

  return (
    <form
      onSubmit={handleSubmit}
      noValidate
      className="w-full bg-white border border-slate-200 p-8 md:p-10"
      data-testid="newsletter-form"
    >
      <div className="grid grid-cols-1 gap-6">
        <div>
          <label
            htmlFor="nl-name"
            className="block text-xs font-bold uppercase tracking-[0.18em] text-slate-700 mb-2"
          >
            {t("newsletter.name_label")}
          </label>
          <input
            id="nl-name"
            type="text"
            autoComplete="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder={t("newsletter.name_placeholder")}
            required
            className={`w-full border-b-2 bg-transparent py-3 text-slate-800 placeholder-slate-400 focus:outline-none ${
              error && !name.trim()
                ? "border-red-500"
                : "border-slate-300 focus:border-[#1E3A8A]"
            }`}
            data-testid="newsletter-name-input"
          />
        </div>
        <div>
          <label
            htmlFor="nl-email"
            className="block text-xs font-bold uppercase tracking-[0.18em] text-slate-700 mb-2"
          >
            {t("newsletter.email_label")}
          </label>
          <input
            id="nl-email"
            type="email"
            autoComplete="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder={t("newsletter.email_placeholder")}
            required
            className={`w-full border-b-2 bg-transparent py-3 text-slate-800 placeholder-slate-400 focus:outline-none ${
              error && !validateEmail(email)
                ? "border-red-500"
                : "border-slate-300 focus:border-[#1E3A8A]"
            }`}
            data-testid="newsletter-email-input"
          />
        </div>
        <label className="flex items-start gap-3 text-xs text-slate-600 leading-relaxed">
          <input
            type="checkbox"
            checked={consent}
            onChange={(e) => setConsent(e.target.checked)}
            className="mt-1 h-4 w-4 border-slate-300 accent-[#1E3A8A]"
            data-testid="newsletter-consent"
          />
          <span>{t("newsletter.consent")}</span>
        </label>

        <button
          type="submit"
          className="w-full md:w-auto px-8 py-4 bg-[#1E3A8A] text-white font-semibold text-sm uppercase tracking-[0.18em] hover:bg-[#152b6a] disabled:opacity-60"
          disabled={!consent}
          data-testid="newsletter-submit"
        >
          {t("newsletter.submit")}
        </button>
        <p className="text-xs text-slate-500">{t("newsletter.reassurance")}</p>
      </div>
    </form>
  );
}
